import React from "react";

const Whychoose = () => {
  return (
    <section className="max-w-[1400px] mx-auto px-0 py-2">
      {/* Heading */}
      <div className="max-w-[850px] mx-auto text-center mb-20">
        <span
          className="uppercase tracking-[3px] text-[#B68A35] text-[14px] font-medium"
          style={{ fontFamily: "Poppins" }}
        >
          Why Choose Us
        </span>

        <h2
          className="text-[55px] leading-tight text-[#0F172A] mt-4"
          style={{ fontFamily: "Pochaevsk" }}
        >
          Why Choose Benzies Concierge Services
        </h2>

        <p
          className="text-[17px] text-gray-500 mt-6 leading-8"
          style={{ fontFamily: "Poppins" }}
        >
          Our experienced team and trusted network of professionals ensure that
          every aspect of your relocation, investment, and lifestyle in Spain
          is handled with care, efficiency, and complete peace of mind.
        </p>
      </div>

      {/* Cards */}
      <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
        {/* Card 1 */}
        <div className="bg-[#F9F8F4] rounded-[30px] p-10 transition duration-500 hover:-translate-y-3 hover:shadow-2xl">
          <div className="w-[80px] h-[80px] rounded-full bg-[#B68A35] flex items-center justify-center text-white text-[30px] mb-8">
            <i className="fa-solid fa-location-dot"></i>
          </div>

          <h3
            className="text-[28px] text-[#0F172A] mb-5"
            style={{ fontFamily: "Pochaevsk" }}
          >
            Local Expertise
          </h3>

          <p
            className="text-[15px] text-gray-500 leading-8"
            style={{ fontFamily: "Poppins" }}
          >
            Benefit from extensive knowledge of the Spanish property market,
            regulations, and local lifestyle.
          </p>
        </div>

        {/* Card 2 */}
        <div className="bg-[#F9F8F4] rounded-[30px] p-10 transition duration-500 hover:-translate-y-3 hover:shadow-2xl">
          <div className="w-[80px] h-[80px] rounded-full bg-[#B68A35] flex items-center justify-center text-white text-[30px] mb-8">
            <i className="fa-solid fa-handshake"></i>
          </div>

          <h3
            className="text-[28px] text-[#0F172A] mb-5"
            style={{ fontFamily: "Pochaevsk" }}
          >
            Trusted Network
          </h3>

          <p
            className="text-[15px] text-gray-500 leading-8"
            style={{ fontFamily: "Poppins" }}
          >
            Access a carefully selected network of lawyers, banks, schools,
            insurance providers, and service partners.
          </p>
        </div>

        {/* Card 3 */}
        <div className="bg-[#F9F8F4] rounded-[30px] p-10 transition duration-500 hover:-translate-y-3 hover:shadow-2xl">
          <div className="w-[80px] h-[80px] rounded-full bg-[#B68A35] flex items-center justify-center text-white text-[30px] mb-8">
            <i className="fa-solid fa-sliders"></i>
          </div>

          <h3
            className="text-[28px] text-[#0F172A] mb-5"
            style={{ fontFamily: "Pochaevsk" }}
          >
            Tailored Solutions
          </h3>

          <p
            className="text-[15px] text-gray-500 leading-8"
            style={{ fontFamily: "Poppins" }}
          >
            Every service is personalized to suit your needs, goals, and
            lifestyle requirements.
          </p>
        </div>

        {/* Card 4 */}
        <div className="bg-[#F9F8F4] rounded-[30px] p-10 transition duration-500 hover:-translate-y-3 hover:shadow-2xl">
          <div className="w-[80px] h-[80px] rounded-full bg-[#B68A35] flex items-center justify-center text-white text-[30px] mb-8">
            <i className="fa-solid fa-shield-heart"></i>
          </div>

          <h3
            className="text-[28px] text-[#0F172A] mb-5"
            style={{ fontFamily: "Pochaevsk" }}
          >
            Stress-Free Experience
          </h3>

          <p
            className="text-[15px] text-gray-500 leading-8"
            style={{ fontFamily: "Poppins" }}
          >
            From paperwork to everyday life, we simplify every step so you can
            enjoy your new life in Spain with confidence.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Whychoose;